import languageService from '../../services/language.service';
import languageActionTypes from '../types/languageActionTypes';

export const getLanguage = () => (dispatch) => {
    var lang = languageService.getLanguage();
    dispatch({
        type: languageActionTypes.GET_CURRENT_LANGUAGE,
        payload: lang,
    });
};

export const setLanguage = lang => dispatch => {
    try {
        languageService.setLanguage(lang);
        dispatch({
            type: languageActionTypes.SET_CURRENT_LANGUAGE_SUCCESS,
            payload: lang,
        });
    } catch (error) {
        dispatch({
            type: languageActionTypes.SET_CURRENT_LANGUAGE_FAILURE,
            payload: 'HE',
        });
    }
};


const langActions = {
    getLanguage,
    setLanguage,
};
export default langActions;

// export const setSelectedCharger = selectedCharger => dispatch => {
//     localStorage.setItem('selectedCharger', JSON.stringify(selectedCharger));
//     dispatch({ type: 'SELECTE_CHARGER', payload: selectedCharger });
// };